import { postApiV2SessionLoginMethod } from '@shared/integrations/taf-api/v2/features/session/session';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@shared/features/toasts/contexts/ToastProvider.tsx';
import useGetGlobalSiteSettings from '@shared/features/global-site-settings/hooks/useGetGlobalSiteSettings';
import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';
import { Navigate } from '@tanstack/react-router';
import AuthenticationErrors from '@my-pages/features/auth/AuthenticationErrors.tsx';

const useLoginRedirect = () => {
    const { t } = useTranslation();
    const { dangerToast } = useToast();
    const [redirecting, setRedirecting] = useState<string | boolean | null>();

    const bankIdLogin = async () => {
        setRedirecting('bankId');
        const params = new URLSearchParams(window.location.search);
        let callbackUrl = window.location.protocol + '//' + window.location.host;

        if (params.has('returnUrl')) callbackUrl += params.get('returnUrl');

        await postApiV2SessionLoginMethod('bankId', { callbackUrl: callbackUrl })
            .then((data) => {
                if (!data || !data.redirectUrl) {
                    dangerToast(t('login.bankIdFail'));
                    return;
                } 
                window.location.href = data.redirectUrl;
            })
            .catch((error) => {
                dangerToast(t('login.bankIdFail'));
                console.log(error);
            });
        setRedirecting(null);
    };

    return { redirecting, bankIdLogin };
};

const Login = () => {
    const { isAuthenticated } = useApplicationStore();
    const authenticationError = useApplicationStore((state) => state.authenticationError);

    const { becomeMemberUrl } = useGetGlobalSiteSettings();
    const [BackDoorHandler, setBackDoorHandler] = useState<any | undefined>();
    const { t } = useTranslation();
    const { redirecting, bankIdLogin } = useLoginRedirect();

    useEffect(() => {
        //@ts-ignore
        if (import.meta.env.DEV) {
            import('@my-pages/utils/BackDoorHandler')
                .then((module) => {
                    setBackDoorHandler(() => module.default);
                })
                .catch((error) => {
                    console.error('Failed to load the development module:', error);
                });
        }
    }, []);

    if (isAuthenticated) return <Navigate to={'/$'} params={{_splat: '/'}} />;

    return (<div className="d-flex flex-wrap justify-content-center mt-6">
        <div className='card-login'> 
            {authenticationError ?<AuthenticationErrors error={authenticationError} /> :null}
            <div className=' card card-body  mt-4  mb-4 mb-md-5 border slide-up-fade-in'>
                <h4>{t('login.loginTitle')}</h4>
                <form>
                    <div className='form-group'>
                        <button
                            type='button'
                            disabled={redirecting === 'bankId'}
                            className=' btn btn-primary btn-block py-3'
                            onClick={() => bankIdLogin()}
                        >
                            {redirecting === 'bankId' && (
                                <div
                                    style={{ display: 'inline-block', margin: 0 }}
                                    className='mr-3 spinner spinner-linear spinner-white fade-in'
                                ></div>
                            )}
                            {t('login.useBankId')}
                        </button>
                    </div>
                    {BackDoorHandler ? (
                        <div className='form-group'>
                            <BackDoorHandler />
                        </div>
                    ) : null}
                </form>
                <div className='form-text text-muted'>{t('login.intro')}</div>
            </div>
            {becomeMemberUrl ? (
                <div className='text-center text-muted fade-in-medium'>
                    Saknar du medlemskap?{' '}
                    <a
                        type='button'
                        className='btn-none text-primary ml-2'
                        href={becomeMemberUrl}
                    >
                        <span className='btn-text-link'>Bli medlem</span>
                    </a>
                </div>
            ) : null}
        </div>
        </div>
    );
};

export default Login;
